
export var webviewJsObjectName = "android";
export const isRealInAndroid = typeof window !== 'undefined' && webviewJsObjectName in window;
if(typeof window !== 'undefined'){
    (window as any)["isRealInAndroid"] = isRealInAndroid;
}
interface IWindow{
    [key:string]:any
}

export function getAndroid(){
    if(typeof window === 'undefined')return undefined;
    const w = window as IWindow;
    return w[webviewJsObjectName]
}
export function isInAndroid(){
    if(typeof window === 'undefined')return false;
    return webviewJsObjectName in window;
}
